function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import styled from 'styled-components';
import { Box } from 'rebass/styled-components';
import { height } from 'styled-system';
export var WidthWrapper = styled(Box)(_templateObject(), height);
